import type { FaireProductEntity } from "../../entity_types/product";

export const p_carq2n9wxg: FaireProductEntity = {
  token: "p_carq2n9wxg",
  type: "product",
  name: "Western Pink / Muslin Ruffle Sunsuit",
  brandToken: "b_hpgmw3yct2",
  brandName: "SIIX Collection",
  imageUrl:
    "https://cdn.faire.com/fastly/5ce076c7679c7d1f1f1243d7e12d4c450df792bf63e3021dcb519041b0069c58.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a24a58b839aadec30b7752853beb068bc2df0aac82f70d8bb71b536245a3a0ab.jpeg",
    "https://cdn.faire.com/fastly/6138053e04871a34fa627ffecd0f00c3d2d3bed12b530b30e76eb645ff4de1ba.jpeg",
  ],
  priceDollars: 14,
  description:
    "Introducing Our New Spring/Summer Muslin Collection from SIIX Collection!\n\nExperience the perfect blend of softness and breathability with our latest muslin pieces, designed for effortless style and comfort all season long.\n\nGarment & Care Details:\n\n * Made from 100% Organic Cotton Muslin \n * Machine wash cold, tumble dry low, or hang dry \n * Avoid high heat to maintain the perfect fit, as 100% cotton may shrink ",
  tags: [],
  msrpDollars: 28,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:50:30.698Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
